<template>
    <div align="center">
        <div class="commonSearch bottom" ref="commonSearchRef" :style="defaultHeight">
            <el-form class="el-form" ref="ruleForm" label-width="100px" :rules="rules" :model="form" style="margin-top: 30px" label-position="left">
                <el-form-item prop="userid">
                    <span slot="label">
                        <span class="span-box">
                            <i class="el-icon-postcard" />
                            <span>学号/工号</span>
                        </span>
                    </span>
                    <el-input v-model="form.usercode" :disabled="true" style="width: 300px"></el-input>
                </el-form-item>
                <el-form-item prop="telephone">
                    <span slot="label">
                        <span class="span-box">
                            <i class="el-icon-mobile-phone" />
                            <span>电话</span>
                        </span>
                    </span>
                    <el-input v-model="form.telephone" placeholder="填写电话" style="width: 300px"></el-input>
                </el-form-item>
                <el-form-item prop="studentname">
                    <span slot="label">
                        <span class="span-box">
                            <i class="el-icon-user" />
                            <span>联系人</span>
                        </span>
                    </span>
                    <el-input v-model="form.studentname" placeholder="填写报修人姓名" style="width: 300px"></el-input>
                </el-form-item>

                <el-form-item prop="faulttype">
                    <span slot="label">
                        <span class="span-box">
                            <i class="el-icon-warning-outline" />
                            <span>故障类型</span>
                        </span>
                    </span>
                    <el-select v-model="form.faulttype" placeholder="选择故障类型" style="width: 300px">
                        <el-option v-for="item in gzlxs" :key="item.id" :label="item.name" :value="item.code"> </el-option>
                    </el-select>
                </el-form-item>

                <el-form-item prop="region">
                    <span slot="label">
                        <span class="span-box">
                            <i class="el-icon-guide" />
                            <span>区域</span>
                        </span>
                    </span>
                    <el-select v-model="form.region" @change="handleSelectionChange" placeholder="选择区域" style="width: 300px">
                        <el-option v-for="item in xqqys" :key="item.id" :label="item.name" :value="item.code"> </el-option>
                    </el-select>
                </el-form-item>

                <el-form-item prop="buliding">
                    <span slot="label">
                        <span class="span-box">
                            <i class="el-icon-office-building" />
                            <span>楼宇</span>
                        </span>
                    </span>
                    <el-select v-model="form.buliding" placeholder="请选择楼宇" style="width: 300px">
                        <el-option v-for="item in lys" :key="item.id" :label="item.name" :value="item.code">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item prop="detailedaddress">
                    <span slot="label">
                        <span class="span-box">
                            <i class="el-icon-map-location" />
                            <span>详细地址</span>
                        </span>
                    </span>
                    <el-input v-model="form.detailedaddress" placeholder="填写详细地址,例如房间号" style="width: 300px"></el-input>
                </el-form-item>
                <el-form-item prop="repairtime">
                    <span slot="label">
                        <span class="span-box">
                            <i class="el-icon-time" />
                            <span>预约时间</span>
                        </span>
                    </span>
                    <el-date-picker style="width: 300px" v-model="form.repairtime" class="date_picker" type="datetime" :picker-options="pickerOptions" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择日期时间" default-time="10:00:00"> </el-date-picker>
                </el-form-item>

                <el-form-item prop="faultdescription">
                    <span slot="label">
                        <span class="span-box">
                            <i class="el-icon-edit-outline" />
                            <span>故障描述</span>
                        </span>
                    </span>
                    <el-input type="textarea" :rows="6" placeholder="例如:上不了网,网络慢" v-model="form.faultdescription" style="width: 300px"> </el-input>
                </el-form-item>

                <el-form-item prop="">
                    <span slot="label">
                        <span class="span-box">
                            <i class="el-icon-upload2" />
                            <span>图片上传</span>
                        </span>
                    </span>
                    <div style="width: 500px;height: auto;border: 1px dashed #d9d9d9;padding-top: 10px;padding-bottom: 10px;">
                        <el-upload :class="{ disabled: uploadDisabled }" :action="doUpload" list-type="picture-card" :http-request="customUpload" :on-exceed="uploadOverrun" :on-success="handleAvatarSuccess" :on-remove="handleRemove" :on-change="handleChange" :before-upload="beforeAvatarUpload" :file-list="fileList" drag :limit="9">
                            <i class="el-icon-plus"></i>
                        </el-upload>
                    </div>
                </el-form-item>

                <el-form-item>
                    <span slot="label">
                        <span class="span-box">
                            <i class="el-icon-upload2" />
                            <span>视频上传</span>
                        </span>
                    </span>
                    <div style="width: 500px;height: auto;border: 1px dashed #d9d9d9;padding-top: 10px;padding-bottom: 10px;">
                        <img v-if="videoForm.showVideoPath !='' && !videoFlag" class="del" src="http://www.qunlisoft.com/keqiaotown/mptourists/images/touristNote/del.png" @click="delImg2()" />
                        <video v-if="videoForm.showVideoPath !='' && !videoFlag" :src="videoForm.showVideoPath" class="avatar video-avatar" controls="controls">
                            您的浏览器不支持视频播放
                        </video>

                        <el-upload v-if="videoForm.showVideoPath =='' " class="avatar-uploader" list-type="picture-card" :action="doUploadVideo" :data="{recordId: '',typeId: '998102', noLogin: '1' ,}" :on-progress="uploadVideoProcess" :on-success="handleVideoSuccess" :before-upload="beforeUploadVideo" :show-file-list="false">
                            <i v-if="videoForm.showVideoPath =='' && !videoFlag" class="el-icon-plus "></i>
                            <el-progress v-if="videoFlag == true" type="circle" :percentage="videoUploadPercent" style="margin-top:7px;"></el-progress>
                        </el-upload>
                    </div>
                </el-form-item>

                <el-form-item>
                    <el-button type="primary" v-if="!uploadFlag" @click="submitForm('ruleForm')" style="width: 300px; margin-top: 20px;margin-bottom: 25px">提交</el-button>
                    <el-button v-if="uploadFlag" style="color: #508BD5;border-color: #508BD5;margin-right: 35px" @click="submitForm('ruleForm')">提交</el-button>
                    <el-button v-if="uploadFlag" style="color: #508BD5;border-color: #508BD5;margin-right: 35px;margin-bottom: 20px;" @click="rollBack">返回</el-button>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>

<script>
import TabResize from "@/utils/TabResizeEx.js";
import SettingApi from "@/api/setting.js";
import RepairsApi from "@/api/repairs.js";

export default {
    mixins: [TabResize],
    components: {},

    data () {
        return {
            value1: "",
            form: {
                buliding: "",
                createdate: "",
                detailedaddress: "",
                faultdescription: "",
                faulttype: "",
                region: "",
                repaircode: "",
                repairtime: "",
                repersonnel: "",
                status: "",
                studentname: "",
                telephone: "",
                usercode: "",
                orderid: "",
            },
            videoFlag: false,
            //是否显示进度条
            videoUploadPercent: "",
            //进度条的进度，
            isShowUploadVideo: false,
            //显示上传按钮
            videoForm: {
                videoid: '',
                showVideoPath: ''
            },
            params: {
                file: "",
                recordId: "",
                typeId: "998102",
                noLogin: "1",
            },
            showPlus: true,
            defaultHeight: {
                height: ""
            },
            qyCode: "",
            doUpload: this.$constant.API_NSC + "file/upload/single",
            doUploadVideo: "http://127.0.0.1:8991" + this.$constant.API_NSC + "file/upload/single",
            loading: true,
            overAllRecordId: "",
            uploadDisabled: false,
            uploadFlag: false, //是否是编辑或新增
            gzlxs: [], //故障类型
            xqqys: [], //校区
            lys: [], //楼宇
            fileList: [], //展示图片信息
            filevideoList: [],
            imgUid: [], //新增上传图片id集合
            imgs: [],  //新上传图片移除图片的集合
            pictures: [], //查询到的所有图片的id
            moveIds: [],  //原有图片移除图片的集合
            fits: [],   //查询到图片的集合
            imageUrl: "", // 对话框图像路径
            dialogVisible: false, // 对话框可见

            rules: {
                telephone: [
                    {
                        required: true,
                        message: "电话不能为空",
                        trigger: "blur",
                    },
                    {
                        pattern: /^([1]\d{10}|\d{8})$/,
                        message: "规格不符，请重新输入",
                        trigger: "blur",
                    },
                ],
                studentname: [
                    {
                        required: true,
                        message: "联系人不能为空",
                        trigger: "blur",
                    },
                    {
                        min: 0,
                        max: 12,
                        message: "联系人不能超过12个字符，请重新输入",
                        trigger: "blur",
                    }
                ],
                region: [
                    {
                        required: true,
                        message: "区域不能为空",
                        trigger: "change",
                    }
                ],
                buliding: [
                    {
                        required: true,
                        message: "楼宇不能为空",
                        trigger: "change",
                    }
                ],
                detailedaddress: [
                    {
                        required: true,
                        message: "详细地址不能为空",
                        trigger: "blur",
                    },
                    {
                        min: 0,
                        max: 20,
                        message: "详细地址不能超过20个字符，请重新输入",
                        trigger: "blur",
                    }
                ],
                repairtime: [
                    {
                        required: false,
                        message: "预约时间不能为空",
                        trigger: "blur",
                    }
                ],
                faultdescription: [
                    {
                        required: true,
                        message: "故障描述不能为空",
                        trigger: "blur",
                    },
                    {
                        min: 0,
                        max: 200,
                        message: "故障描述不能超过200个字符，请重新输入",
                        trigger: "blur",
                    }
                ]
            },
            pickerOptions: {
                disabledDate (time) {
                    return time.getTime() <= Date.now();
                },
            }
        };
    },

    mounted: function () {
        let currentUser = this.$constant.GET_USER();
        this.form.usercode = currentUser.userName;

        this.findOptions("1002", "gzlxs");
        this.findOptions("1003", "xqqys");

        if (this.$route.query.id != null) {
            let id = this.$route.query.id;
            this.uploadFlag = true;
            this.overAllRecordId = id;
            this.findOrderById(id);
            this.findImg(id);
            this.findvideo(id);
        } else {
            this.overAllRecordId = "";
        }
    },

    methods: {
        getHeight () {
            this.defaultHeight.height = window.innerHeight - 90 + "px";
        },
        handleSelectionChange (value) {
            this.qyCode = value;
            this.form.buliding = "";
            this.findOptions(this.qyCode, "lys");
        },

        findOptions (code, key) {
            SettingApi.getClass()
                .Findcode(code)
                .then((resp) => {
                    if (this.$constant.BIZ_RESPONSE_CODE == resp.data.code) {
                        this[key] = resp.data.data;

                        // “故障类型”设置默认值
                        if (!this.overAllRecordId && key == "gzlxs") {
                            this.form.faulttype = this[key][0].code;
                        }
                        if(key == "xqqys"){
                            for(let i=0; i<this[key].length; i++){
                                    if(this[key][i].code == '100304'){
                                        this[key].splice(i, 1)
                                    }
                                 }
                        }
                    } else {
                        this.$message.error(resp.data.msg);
                        return false;
                    }
                }).catch((err) => {
                    this.$message.error(err);
                    return false;
                });
        },

        //回显数据
        findOrderById (id) {
            RepairsApi.getClass()
                .findOrderById(id)
                .then((resp) => {
                    if (this.$constant.BIZ_RESPONSE_CODE == resp.data.code) {
                        let data = resp.data.data;
                        this.form = data;
                        let currentUser = this.$constant.GET_USER();
                        this.form.usercode = currentUser.userName;
                        this.findOptions(this.form.region, "lys");
                    } else {
                        this.$message.error(resp.data.msg);
                        return false;
                    }
                }).catch((err) => {
                    this.$message.error(err);
                    return false;
                });
        },

        //修改报修单,查询上传的图片
        findImg (id) {
            let typeId = 9981;
            this.$mhttp.httpGet(this.$constant.API_NSC + "file/files/type/" + typeId + "/record/" + id, null, null).then((resp) => {
                if (this.$constant.BIZ_RESPONSE_CODE == resp.data.code) {
                    let data = resp.data.data;
                    if (data.length >= 9) {
                        this.uploadDisabled = true
                    }
                    this.fits = data;
                    for (var i = 0; i < data.length; i++) {
                        this.pictures.push(data[i].id);
                    }
                    this.loadImage(this.pictures);
                } else {
                    this.$message.error(resp.data.msg);
                    return false;
                }
            }).catch((err) => {
                this.$message.error(err);
                return false;
            });
        },

        //修改报修单,查询上传的视频
        findvideo (id) {
            let typeId = 998102;
            this.$mhttp.httpGet(this.$constant.API_NSC + "file/files/type/" + typeId + "/record/" + id, null, null).then((resp) => {
                if (this.$constant.BIZ_RESPONSE_CODE == resp.data.code) {
                    let data = resp.data.data;
                    if (this.$utils.isEmpty(data)) {
                        this.videoForm.videoid = data[0].id;
                        this.loadImage2(data[0].id);
                    }
                } else {
                    this.$message.error(resp.data.msg);
                    return false;
                }
            }).catch((err) => {
                this.$message.error(err);
                return false;
            });
        },

        //上传前回调
        beforeUploadVideo (file) {
            var fileSize = file.size / 1024 / 1024 < 50;
            if (['video/mp4', 'video/ogg', 'video/flv', 'video/avi', 'video/wmv', 'video/rmvb', 'video/mov'].indexOf(file.type) == -1) {
                layer.msg("请上传正确的视频格式");
                return false;
            }
            if (!fileSize) {
                layer.msg("视频大小不能超过50MB");
                return false;
            }
            this.isShowUploadVideo = false;
        },
        //进度条
        uploadVideoProcess (event, file, fileList) {
            this.videoFlag = true;
            this.videoUploadPercent = file.percentage.toFixed(0) * 1;
        },
        //上传成功回调
        handleVideoSuccess (res, file) {
            this.isShowUploadVideo = true;
            this.videoFlag = false;
            this.videoUploadPercent = 0;
            this.filevideoList = [];

            //前台上传地址
            if (file.status == 'success') {
                this.videoForm.showVideoPath = URL.createObjectURL(file.raw);
                this.videoForm.videoid = res.data.id;
            } else {
                layer.msg("上传失败，请重新上传");
            }
        },

        delImg2 () {
            console.log("删除集合", this.videoForm.videoid);
            let fileid = this.videoForm.videoid;
            RepairsApi.getClass()
                .filedel(fileid)
                .then((resp) => {
                    if (this.$constant.BIZ_RESPONSE_CODE == resp.data.code) {
                        this.videoForm.showVideoPath = "";
                        this.videoForm.videoid = "";
                        this.$message.success("删除成功");
                    }
                })
                .catch((err) => {
                    this.$message.error(err);
                    return false;
                });
        },

        //上传图片
        customUpload (file) {
            let param = {
                file: file.file,
                recordId: "",
                typeId: "9981", //创建报修单上传图片的typeId
            };
            this.$mhttp
                .httpFilePost(
                    this.$constant.API_NSC + "file/upload/single",
                    param,
                    null,
                    (progress) => {
                        let loaded = progress.loaded,
                            total = progress.total;
                        this.$nextTick(() => {
                            this.percent = Math.floor((loaded / total) * 100) > 1 ? Math.floor((loaded / total) * 100) : 1;
                        });
                    }
                ).then((resp) => {
                    if (this.$constant.BIZ_RESPONSE_CODE == resp.data.code) {
                        this.imageUrl = URL.createObjectURL(file.file);
                        // this.imgUid 新增图片id
                        this.imgUid.push(resp.data.data.id);
                        this.imgs.push({
                            uid: file.file.uid,
                            id: resp.data.data.id
                        });
                        this.$message.success("上传成功！");
                    } else {
                        this.$message.error(resp.data.msg);
                        return false;
                    }
                }).catch((err) => {
                    this.$message.error(err);
                    return false;
                });
        },

        //上传图片限制数量
        uploadOverrun: function () {
            this.$message({
                type: "error",
                message: "上传文件个数超出限制!最多上传9张图片!",
            });
        },
        //上传成功
        handleAvatarSuccess (res, file) {
            this.imageUrl = URL.createObjectURL(file.raw);
        },
        //上传图片限制数量
        handleChange (file, fileList) {
            if (fileList.length >= 9) {
                this.uploadDisabled = true;
            }
        },
        //移除图片
        handleRemove: function (file, fileList) {
            this.moveIds.push(file);
            this.uploadDisabled = false;
        },

        //上传图片前检查
        beforeAvatarUpload (file) {
            const isJPG = file.type === "image/jpeg" || file.type === "image/png" || file.type === "image/jpg";
            const isLt2M = file.size / 1024 / 1024 < 2;

            if (!isJPG) {
                this.$message.error("上传头像图片只能是 JPG/JPEG/PNG 格式!");
            }
            if (!isLt2M) {
                this.$message.error("上传头像图片大小不能超过 2MB!");
            }
            return isJPG && isLt2M;
        },

        //加载图片
        loadImage (userIcons) {
            let imgIds = userIcons;
            for (var i = 0; i < imgIds.length; i++) {
                let item = imgIds[i];
                RepairsApi.getClass()
                    .downloadFile(item)
                    .then((resp) => {
                        let data = resp.data;
                        if (data != null) {
                            this.fileList.push({
                                id: item,
                                url: URL.createObjectURL(resp.data),
                            });
                        } else {
                            this.fileList.push("@/assets/images/main/headImg.png");
                        }
                    }).catch((err) => {
                        this.fileList.push("@/assets/images/main/headImg.png");
                        return false;
                    });
            }
        },

        //加载视频
        loadImage2 (userIcons) {
            let imgIds = userIcons;
            RepairsApi.getClass()
                .downloadFile(imgIds)
                .then((resp) => {
                    let data = resp.data;
                    if (data != null) {
                        console.log("视频结构", data);
                        this.videoForm.showVideoPath = URL.createObjectURL(resp.data);
                    }
                }).catch((err) => {
                    this.$message.error("查询失败");
                    return false;
                });
        },

        //提交数据
        submitForm (formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    let param;
                    if (this.uploadFlag) {
                        for (let a in this.gzlxs) {
                            if (this.gzlxs[a].name == this.form.faulttype) {
                                this.form.faulttype = this.gzlxs[a].code;
                            }
                        }
                        for (let b in this.xqqys) {
                            if (this.xqqys[b].name == this.form.region) {
                                this.form.region = this.xqqys[b].code;
                            }
                        }
                        for (let c in this.lys) {
                            if (this.lys[c].name == this.form.buliding) {
                                this.form.buliding = this.lys[c].code;
                            }
                        }
                    }
                    let currentUser = this.$constant.GET_USER();
                    this.form.userid = currentUser.id
                    param = this.form;
                    RepairsApi.getClass()
                        .saveOrUpdate(param)
                        .then((resp) => {
                            if (this.$constant.BIZ_RESPONSE_CODE == resp.data.code) {
                                this.orderid = resp.data.data.orderid;
                                //上传图片绑定报修单id
                                if (this.imgUid.length > 0) {
                                    this.updateFile(this.orderid, this.imgUid);
                                }
                                if (this.videoForm.videoid != '' && !this.videoFlag) {
                                    this.updateFile2(this.orderid, this.videoForm.videoid);
                                }
                                //去除旧图片
                                this.moveIds.forEach((item, index) => {
                                    if (this.$utils.arrayObjIndexOf(this.fits, item, "id") != -1) {
                                        this.handleRemoves(item);
                                    }
                                });
                                //去除新上传图片
                                this.imgs.forEach((item, index) => {
                                    if (this.$utils.arrayObjIndexOf(this.moveIds, item, "uid") != -1) {
                                        this.handleRemoves(item);
                                    }
                                });

                                this.$message.success("保存成功！");
                                //刷新右边列表数据
                                this.$router.push({
                                    name: "WarrantyList",
                                });
                            } else {
                                this.$message.error(resp.data.msg);
                                return false;
                            }
                        }).catch((err) => {
                            this.$message.error(err);
                            return false;
                        });
                } else {
                    return false;
                }
            });
        },

        //改变上传图片recordId
        updateFile (recordId, imgUid) {
            let param = {
                ids: imgUid,
            };
            RepairsApi.getClass()
                .updateFileFlag(recordId, param)
                .then((resp) => {
                    if (this.$constant.BIZ_RESPONSE_CODE == resp.data.code) {

                    } else {
                        this.$message.error(resp.data.msg);
                        return false;
                    }
                }).catch((err) => {
                    this.loading = false;
                    this.$message.error(err);
                    return false;
                });
        },

        updateFile2 (recordId, videoid) {
            let ids = Array();
            ids.push(videoid);
            let param = {
                ids: ids,
            };
            RepairsApi.getClass()
                .updateFileFlag(recordId, param)
                .then((resp) => {
                    if (this.$constant.BIZ_RESPONSE_CODE == resp.data.code) {

                    } else {
                        this.$message.error(resp.data.msg);
                        return false;
                    }
                }).catch((err) => {
                    this.loading = false;
                    this.$message.error(err);
                    return false;
                });
        },

        //保存时移除图片
        handleRemoves (val) {
            let param = { id: val.id };
            this.$mhttp
                .httpPost(
                    this.$constant.API_NSC + "file/del/" + param.id,
                    null,
                    "application/json"
                )
                .then((resp) => {
                    if (this.$constant.BIZ_RESPONSE_CODE == resp.data.code) {

                    } else {
                        this.$message.error(resp.data.msg);
                        return false;
                    }
                }).catch((err) => {
                    this.$message.error(err);
                    return false;
                });
        },

        //返回上一页
        rollBack () {
            this.$router.push({
                name: "ViewDetails",
                query: { id: this.overAllRecordId }
            });
        }
    },

    created () {
        window.addEventListener("resize", this.getHeight);
        this.getHeight();
    }
};
</script>

<style lang="stylus" scoped>
.top {
    margin-top: 10px;
    margin-bottom: 20px;
    text-align: left;
    font-size: 18px;
    width: 90%;
    color: #F8F8FF;
    height: 30px;
    background-color: #3D84FF;
}

.video-avatar {
    width: 500px;
    height: 300px;
}

.bottom {
    width: 90%;
    height: 820px;
    overflow: auto;
}

.el-form {
    width: 32%;
    height: 90%;

    .el-form-item {
        margin-bottom: 10px;
    }
}

.upload {
    background-color: #fff;
    border-radius: 6px;
    box-sizing: border-box;
    height: 120px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}

/deep/.el-button--small {
    margin-left: 20px;
}

.commonSearch .el-form .el-form-item {
    margin-bottom: 15px !important;
}

/deep/ .el-form-item__error {
    color: #F56C6C;
    font-size: 12px;
    line-height: 1;
    padding-top: 4px;
    position: absolute;
    top: 100%;
    left: 0;
    margin-left: 50px !important;
}

/deep/ .el-input__inner { /* 或者 .s2>>>.el-input__inner */
    width: 300px;
    height: 30px;
    line-height: 30px;
    border-radius: 0px !important; /* 输入框圆角值 */
}

/deep/.el-upload--text, /deep/.el-upload-dragger {
    width: 100%;
    height: 100%;

    .el-icon-upload {
        margin: 10px 0;
    }
}

/deep/.disabled .el-upload--picture-card {
    display: none !important;
}

.del {
    width: 35rpx !important;
    height: 35rpx !important;
    border-radius: 50%;
    position: absolute;
    z-index: 99;
}
</style>